import { sessionKeys } from '@/entities/session'
import { setUnauthorizedHandler, startMocking } from '@/shared/api'
import { initI18n } from '@/shared/i18n'
import { initObservability } from '@/shared/observability'
import { queryClient } from './query-client'

// Bootstrap до рендера: i18n, observability, MSW (в mock-режиме), и глобальная
// реакция на 401 — сброс session-кэша. Редирект на id.stit.tech/auth/login живёт
// в _app beforeLoad (единая точка), чтобы 401 от session-пробы сам не уводил.
export async function bootstrap(): Promise<void> {
  await initI18n()
  initObservability()

  setUnauthorizedHandler(() => {
    queryClient.setQueryData(sessionKeys.me, null)
  })

  await startMocking()
}
